import store from '../../store'
import { SET_APP_BUSY } from '../app'

/**
 * Set app busy action
 */
export const setAppBusyAction = (busy: boolean): void => {
    store.dispatch({
        type: SET_APP_BUSY,
        busy: busy,
    })
}
